import { useState, useEffect } from "react"

const useScrollPosition = (ref, updateCondition) => {
  let minimumChange, renderCallback

  switch (typeof updateCondition) {
    case "number":
      minimumChange = updateCondition
      break
    case "function":
      renderCallback = updateCondition
      break
    default:
  }

  const [position, setPosition] = useState({ x: 0, y: 0 })

  useEffect(() => {
    if (!ref.current) return
    const el = ref.current

    const handleScroll = () => {
      setPosition(prevPos => {
        const x = el === window ? window.scrollX : el.scrollLeft
        const y = el === window ? window.scrollY : el.scrollTop

        if (minimumChange) {
          return Math.abs(prevPos.x - x) > minimumChange ||
            Math.abs(prevPos.y - y) > minimumChange
            ? { x, y }
            : prevPos
        } else if (renderCallback) {
          return renderCallback(prevPos, { x, y }) ? { x, y } : prevPos
        } else {
          return { x, y }
        }
      })
    }

    el.addEventListener("scroll", handleScroll, { passive: true })

    return () => {
      el.removeEventListener("scroll", handleScroll, { passive: true })
    }
  }, [ref, minimumChange, renderCallback])

  return position
}

export default useScrollPosition
